import React from 'react'
import Header from '../SubComponents/Header'
import CommonAbout from '../CommonComponent/CommonAbout'
import CommonServices from '../CommonComponent/CommonServices'
import CommonProject from '../CommonComponent/CommonProject'
import CommonTeam from '../CommonComponent/CommonTeam'
import CommonContact from '../CommonComponent/CommonContact'
export default function Home() {
  return (
    <>
     <Header/>
     <CommonAbout/>
     <CommonServices/>
     <CommonProject/>
     <CommonTeam/>
     <CommonContact/>
    </>
  )
}
